import './index.less';

import { Popover, PopoverContent, PopoverTrigger } from '@tonic-one/react';
import React, { useCallback, useState } from 'react';

export default function SmartTooltip({
  children,
  forceShow = false,
  content = '',
  contentStyle = {},
  popoverContentStyle = {},
  onlyShowContent = false,
  style = {},
  popoverProps = {},
  closeOnClick = false,
}: any) {
  const [open, setOpen] = useState(false);

  const handleMouseEnter = (e: any) => {
    if (onlyShowContent && !content) return;
    if (forceShow) {
      setOpen(true);
    } else {
      const $content = e.target;
      const isTruncated = $content.offsetWidth < $content.scrollWidth;
      setOpen(isTruncated);
    }
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  const handleClick = useCallback(() => {
    if (closeOnClick) {
      setOpen(false);
    }
  }, [closeOnClick]);

  return (
    <Popover isOpen={open} placement="top" {...popoverProps} trigger="hover">
      <PopoverTrigger className="trigger" style={contentStyle}>
        <div
          className="trigger"
          style={contentStyle}
          onMouseEnter={handleMouseEnter}
          onMouseOver={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        >
          {children}
        </div>
      </PopoverTrigger>
      <PopoverContent
        className="popover"
        style={style}
        PopperProps={{
          usePortal: true,
        }}
      >
        <div className="popoverContent" style={popoverContentStyle}>
          {content || children}
        </div>
      </PopoverContent>
    </Popover>
  );
}
